export default "__VITE_ASSET__da3f31d9__"